module.exports = require('./convert')(
  "eportsfun:;Pdgijkly",
  "f;ypgrtlkOo:sduneij"
)
